<template lang='slm'>
  form.text-left @submit.prevent='formSubmit'
    template v-if='item'
      button.d-none
      .form-group
        label Сервис
        select.form-control v-model='item.service'
          option v-for='name, service in services' :value='service' {{ name }}
      .form-group
        label Ссылка
        input.form-control type='text' name='link' v-model='item.link' v-validate='"required|url"'
        small.text-danger v-show="errors.has('link')" {{ errors.first('link') }}
</template>

<script>
const DEFAULT_SERVICE = 'apple_music';

export default {
  name: 'AdminAlbumServiceLinkModalContent',
  data() {
    return {
      item: null,
      services: {
        // image should present in `assets/img/albums_services/SERVICE_NAME.png`
        apple_music: 'Apple Music',
        deezer: 'Deezer',
        itunes: 'iTunes',
        play_music: 'Play Music',
        spotify: 'Spotify',
        yandex_music: 'Яндекс.Музыка',
        youtube_music: 'Youtube Музыка',
      },
    };
  },
  methods: {
    formSubmit() {
      this.$parent.confirm();
    },
    beforeShow({ album, serviceLink }) {
      this.item = this.$_removeImmutabitity(serviceLink);
      // eslint-disable-next-line no-underscore-dangle
      delete this.item.__typename;
      if (!this.item.service) {
        this.item.service = DEFAULT_SERVICE;
      }
      this.item.albumId = album.id;
    },
  },
  computed: {
    modalContentData() {
      return this.item;
    },
  },
  mounted() {
    this.$on('beforeShow', this.beforeShow);
  },
};
</script>
